import React, { lazy, Suspense } from "react";
import "./App.css";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import ReactGA from "react-ga";
import MediaQuery from "react-responsive";
import { CookieSetting } from "cookiesetting-component";

const Navbar = lazy(() => import("./components/Navbar/Navbar"));
const Header = lazy(() => import("./components/Header"));
const Banner = lazy(() => import("./components/Banner/banner.js"));
const Body = lazy(() => import("./components/Body"));
const Contact = lazy(() => import("./components/ContactUs"));
const SubFooter = lazy(() => import("./components/SubFooter"));
const Footer = lazy(() => import("./components/FooterNew/index"));

function App() {
  const appVersion = appversion.version;
  ReactGA.initialize("UA-131344030-1");
  ReactGA.pageview(window.location.pathname + window.location.search);

  return (
    <CacheBuster
      currentVersion={appVersion}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
    >
      <>
        <Suspense fallback={<div />}>
          <Navbar />
        </Suspense>
        <Suspense fallback={<div />}>
          <Banner />
        </Suspense>
        <MediaQuery maxWidth={991}>
         <Suspense fallback={<div />}>
          <Header />
        </Suspense> 
        </MediaQuery>
        <Suspense fallback={<div />}>
          <Body />
        </Suspense>
        <Suspense fallback={<div />}>
          <Contact />
        </Suspense>
        <Suspense fallback={<div />}>
          <SubFooter />
        </Suspense>
        <Suspense fallback={<div />}>
          <Footer />
        </Suspense>
       <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
      </>
    </CacheBuster>
  );
}

export default App;
